import React from 'react';
import { connect } from 'react-redux';

class VideoLivestreamPlaceholder extends React.PureComponent {
    static propTypes = {
    };

    render() {
        const style = { display: 'none' };
        return (
            <div style={style}>
                {/* eslint-disable-next-line */}
                <video id="webcam_livestream" autoPlay />
                <canvas id="canvas_webcam_livestream" />
            </div>
        );
    }
}

function mapStateToProps() {
    return {
    };
}

const VideoLivestreamPlaceholderContainer = connect(mapStateToProps)(VideoLivestreamPlaceholder);
export default VideoLivestreamPlaceholderContainer;
